import _ from 'underscore';
import { edmCampaign } from '@bingads-webui/edm-campaign';

export const select = [
  'Id',
  'Status',
  'Name',
  'DeliveryStatus',
  'DeliveryStatusDetails',
];

export const readAdGroup = (cid, aid, campaignId, adGroupId) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .AdGroups.$withKey(adGroupId)
    .get()
    .toPromise();

export const readAdGroups = (cid, aid, campaignId, params: Record<string, any> = {}) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .AdGroups['Default.GridData']
    .$makeCall({
      query: {
        count: true,
        filter: { where: params.$filter },
        orderby: params.$orderby,
        select: _.union(params.$select || select, params.$expand),
        skip: params.$skip || 0,
        top: params.$top || 20,
      },
      payload: {
        gridDataParameters: {},
      },
    })
    .toPromise();
